import React, { Children } from 'react';
import { motion } from 'framer-motion';
// Custom Clipboard SVG
const ClipboardIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-320">
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" data-id="element-321" />
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" data-id="element-322" />
    <path d="M9 14h6" data-id="element-323" />
    <path d="M9 18h6" data-id="element-324" />
    <path d="M9 10h.01" data-id="element-325" />
  </svg>;
// Custom Rocket SVG
const RocketIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-326">
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" data-id="element-327" />
    <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" data-id="element-328" />
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" data-id="element-329" />
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" data-id="element-330" />
  </svg>;
// Custom Chart Up SVG
const ChartUpIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-331">
    <path d="M3 3v18h18" data-id="element-332" />
    <path d="m19 9-5 5-4-4-3 3" data-id="element-333" />
    <path d="M19 9h-4" data-id="element-334" />
    <path d="M19 9v4" data-id="element-335" />
  </svg>;
export function ProcesoSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="proceso" className="py-24 bg-brand-black relative border-t border-white/5 overflow-hidden" data-id="element-336">
      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-337">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="text-center mb-20" data-id="element-338">
          <motion.h2 variants={itemVariants} className="font-heading text-brand-yellow text-sm md:text-base tracking-[0.3em] uppercase mb-4" data-id="element-339">
            Nuestro Proceso
          </motion.h2>
          <motion.h3 variants={itemVariants} className="font-heading text-3xl md:text-5xl font-bold text-white" data-id="element-340">
            Así funciona tu tratamiento de crecimiento
          </motion.h3>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-6xl mx-auto relative" data-id="element-341">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-px bg-gradient-to-r from-transparent via-brand-yellow/30 to-transparent z-0" data-id="element-342" />

          {/* Step 1 */}
          <motion.div variants={itemVariants} className="relative z-10 flex flex-col items-center text-center" data-id="element-343">
            <div className="w-24 h-24 rounded-full bg-brand-darker border-2 border-brand-yellow/50 flex items-center justify-center mb-8 relative shadow-[0_0_30px_rgba(212,168,67,0.1)]" data-id="element-344">
              <ClipboardIcon className="w-10 h-10 text-brand-yellow" data-id="element-345" />
              <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-brand-green flex items-center justify-center font-bold text-brand-black font-heading text-lg" data-id="element-346">
                1
              </div>
            </div>
            <h4 className="font-heading text-2xl font-bold text-white mb-4" data-id="element-347">
              Diagnóstico Gratuito
            </h4>
            <p className="text-brand-gray leading-relaxed" data-id="element-348">
              Analizamos tu mercado, competencia y zona. Identificamos
              exactamente dónde están los clientes de alto ticket.
            </p>
          </motion.div>

          {/* Step 2 */}
          <motion.div variants={itemVariants} className="relative z-10 flex flex-col items-center text-center" data-id="element-349">
            <div className="w-24 h-24 rounded-full bg-brand-darker border-2 border-brand-yellow/50 flex items-center justify-center mb-8 relative shadow-[0_0_30px_rgba(212,168,67,0.1)]" data-id="element-350">
              <RocketIcon className="w-10 h-10 text-brand-yellow" data-id="element-351" />
              <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-brand-green flex items-center justify-center font-bold text-brand-black font-heading text-lg" data-id="element-352">
                2
              </div>
            </div>
            <h4 className="font-heading text-2xl font-bold text-white mb-4" data-id="element-353">
              Lanzamiento de Campaña
            </h4>
            <p className="text-brand-gray leading-relaxed" data-id="element-354">
              Activamos ads hiper-segmentados por código postal. Tu teléfono
              empieza a sonar en las primeras 48-72 horas.
            </p>
          </motion.div>

          {/* Step 3 */}
          <motion.div variants={itemVariants} className="relative z-10 flex flex-col items-center text-center" data-id="element-355">
            <div className="w-24 h-24 rounded-full bg-brand-darker border-2 border-brand-yellow/50 flex items-center justify-center mb-8 relative shadow-[0_0_30px_rgba(212,168,67,0.1)]" data-id="element-356">
              <ChartUpIcon className="w-10 h-10 text-brand-yellow" data-id="element-357" />
              <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-brand-green flex items-center justify-center font-bold text-brand-black font-heading text-lg" data-id="element-358">
                3
              </div>
            </div>
            <h4 className="font-heading text-2xl font-bold text-white mb-4" data-id="element-359">
              Escala y Dominio
            </h4>
            <p className="text-brand-gray leading-relaxed" data-id="element-360">
              Optimizamos, escalamos y te convertimos en el líder de tu zona.
              Contratos grandes, agenda llena.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}